import { formatPhone, phoneHref } from '@/lib/phone'
import { cn } from '@/lib/utils'

/** A stored phone number, formatted for dialing and tappable to call when it is a real number (USA-1473). */
export function PhoneNumber({ phone, className }: { phone: string; className?: string }) {
  const href = phoneHref(phone)
  const text = formatPhone(phone)
  if (!href) return <span className={className}>{text}</span>
  return (
    // eslint-disable-next-line no-restricted-syntax -- tel: link, not navigation
    <a href={href} className={cn('whitespace-nowrap hover:underline', className)}>
      {text}
    </a>
  )
}
